import { createContext, useContext } from "react";
import { RootStore } from "@/stores/RootStore";

export const MobixStoreContext = createContext<RootStore | null>(null);

export const useStore = () => {
	const store = useContext(MobixStoreContext);
	if (!store) {
		throw new Error("useStore must be used within a MobixStoreContext.Provider");
	}
	return store;
};
